import { useCallback, useEffect } from 'react'

import { APP_CURRENCIES, CURRENCY_KEY } from '@/constants'
import { getStorageValue, setStorageValue } from '@/utils'
import { TCurrency } from '@/types'
import { useRouter } from '@/i18n'

export const useCurrency = () => {
  const router = useRouter()
  const currency = getStorageValue<TCurrency>(CURRENCY_KEY) as TCurrency

  const onChangeCurrency = useCallback(
    (currency: TCurrency) => {
      setStorageValue(CURRENCY_KEY, currency)
      router.refresh()
    },
    [router],
  )

  useEffect(() => {
    if (!currency) {
      onChangeCurrency(APP_CURRENCIES[0])
    }
  }, [currency, onChangeCurrency])

  return {
    onChangeCurrency,
    currency: currency ?? APP_CURRENCIES[0],
  }
}
